import { ReactNode } from 'react';
import Teaser from '@rio-cloud/rio-uikit/Teaser';

type FeatureTeaserProps = {
  content: ReactNode;
  headline: ReactNode;
  image: string;
  footer?: ReactNode;
  headlineClassName?: string;
  onClick?: () => void;
  'data-testid'?: string;
};

export const FeatureTeaser = ({
  content,
  image,
  headline,
  footer,
  headlineClassName = 'text-size-h4 text-color-primary',
  onClick,
  'data-testid': dataTestId,
}: FeatureTeaserProps) => {
  return (
    <div
      onClick={onClick}
      className={'cursor-pointer'}
      data-testid={dataTestId}
    >
      <Teaser
        className={'hover-bg-highlight-decent'}
        headline={<span className={headlineClassName}>{headline}</span>}
        content={content}
        footer={footer}
        image={{
          src: image,
          aspectRatio: '3:2',
          className: 'padding-top-20 padding-left-20 padding-right-20',
        }}
      />
    </div>
  );
};
